import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TopNavLeftSideActions from './TopNavLeftSideActions/TopNavLeftSideActions';
import TopNavRightSideActions from './TopNavRightSideActions';
import TopNavCenterTabs from './TopNavCenterTabs';
import { blockType } from '../../types';
import { APPLICATION_MODES } from '../../constants/itemTypes/itemTypes';
import * as Styled from './styles';

const TopNav = ({ blocks, applicationMode, setApplicationMode, setPreviewWidth }) => {
    const isCanvasEmpty = blocks.length === 0;

    return (
        <Styled.TopNavDiv>
            <Styled.TopNavActions>
                <TopNavLeftSideActions
                    blocks={blocks}
                    isCanvasEmpty={isCanvasEmpty}
                    // TODO: PIK-2203 Cleanup prop drilling
                    applicationMode={applicationMode}
                    setApplicationMode={setApplicationMode}
                    setPreviewWidth={setPreviewWidth}
                />
                {applicationMode !== APPLICATION_MODES.VERSION_HISTORY &&
                <TopNavCenterTabs
                    // TODO: PIK-2203 Cleanup prop drilling
                    setApplicationMode={setApplicationMode}
                    applicationMode={applicationMode}
                    isCanvasEmpty={isCanvasEmpty}
                />
                }
                <TopNavRightSideActions
                    blocks={blocks}
                    // TODO: PIK-2203 Cleanup prop drilling
                    applicationMode={applicationMode}
                    setApplicationMode={setApplicationMode}
                />
            </Styled.TopNavActions>
            <Styled.TopNavDivider />
        </Styled.TopNavDiv>
    );
};

const mapStateToProps = (state) => ({
    blocks: state.canvasBlocks.present,
});

TopNav.propTypes = {
    blocks: PropTypes.arrayOf(blockType).isRequired,
    applicationMode: PropTypes.string.isRequired,
    setApplicationMode: PropTypes.func.isRequired,
    setPreviewWidth: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(TopNav);
